import { useQuery, UseQueryOptions, UseQueryResult } from 'react-query';
import { Like } from '../../models/Like';
import { fetchLikes } from '../../services/likes/likes.service';
import { queryKeys } from '../queryKeyFactory';

export default (options?: UseQueryOptions<Like[], Error>): UseQueryResult<Like[], Error> => {
  return useQuery<Like[], Error>([queryKeys.fetchLikes.all], () => fetchLikes(), options);
};
